import { MidpointHandle } from './MidpointHandle';
export { MidpointHandle };
export default MidpointHandle;